var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegend0407(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zalevwotka",
    d: "M5 8.5h38v7H5z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "76ieoqkp8b",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 38,
    height: 7,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zalevwotka"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    mask: "url(#76ieoqkp8b)",
    xlinkHref: "#zalevwotka",
    fill: "#E1E1E1",
    stroke: "#D671AF",
    strokeWidth: 2,
    fillRule: "evenodd",
    strokeDasharray: "4,2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegend0407);
export default __webpack_public_path__ + "static/media/icon-legend-04-07.71e4d115dd9558cdc0e3cdb77e5ef59e.svg";
export { ForwardRef as ReactComponent };